import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HTMLBindingDirective } from '@df/ui/common/html-binding.directive';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';

export enum EBackorderDeliveryTimeOption {
    availableNow = 3254
}

@Component({
    selector: 'product-delivery-messages',
    templateUrl: './product-delivery-messages.html',
    standalone: true,
    imports: [CommonModule, HTMLBindingDirective, OptionLabelPipe, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDeliveryMessagesComponent extends UiComponent {
    @Input()
    backorderDeliveryTime?: number;

    @Input()
    deliveryFlag?: number;

    get canShowBackorderDeliveryTime(): boolean {
        return !!this.backorderDeliveryTime && this.backorderDeliveryTime !== EBackorderDeliveryTimeOption.availableNow;
    }
}
